import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal'

import { CharacterContext } from '../../../contexts/character'
import { DBContext } from '../../../contexts/databases'

import ItemDescription from '../../ItemDescription/ItemDescription'

import idnum2itemresnametable from '../../../data/Items/idnum2itemresnametable.json'

function EquipmentModal(props) {
	const { inventory, replaceItemInInventory, maxRefine } =
		useContext(CharacterContext)
	const { item_db_equip, Item } = useContext(DBContext)
	const currentLocation = props.location
	const itemList = props.itemList

	const [seachText, setSearchText] = useState('')
	const customStyles = {
		overlay: {
			// height: '60%',
		},
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			margin: '20px',
			padding: '0px',
			transform: 'translate(-50%, -50%)',
			height: '60%',
			width: '60%',
			overflow: 'hidden',
			// overflow: 'scroll',
		},
	}

	ReactModal.setAppElement('#root')

	let subtitle

	//reset search when modal is openned
	useEffect(() => {
		if (props.modalIsOpen) setSearchText('')
	}, [props.modalIsOpen])

	function afterOpenModal() {
		// references are now sync'd and can be accessed.
		subtitle.style.color = '#f00'
	}

	const handleTextType = (event) => {
		// console.log(event.target.value)
		setSearchText(event.target.value)
	}
	const handleClick = () => {
		// console.log('props.lastSelectedItem', props.lastSelectedItem)
		let newItem = new Item(currentLocation, maxRefine[currentLocation] > 0)
		let newItemFromDB = item_db_equip.find(
			(equip) => equip.Id === parseInt(props.lastSelectedItem),
		)
		console.log('newItemFromDB', newItemFromDB)
		if (newItemFromDB) {
			newItem.setItem(newItemFromDB)
			// console.log('maxRefine[currentLocation]', currentLocation)
			Object.entries(newItem.CardSlots).forEach(([Slot, Compound]) => {
				if (
					Compound.Type !== 'None' &&
					Compound.Type ===
						inventory[currentLocation].CardSlots[Slot].Type
				)
					newItem.CardSlots[Slot].changeSlot(
						inventory[currentLocation].CardSlots[Slot],
					)
				// 		if (Compound.Id !== 0)
				// 			newItem.CardSlots[Slot].changeSlot(
				// 				Compound,
				// 			)
			})
		}
		if (newItem.isRefinable)
			newItem.setRefine(inventory[currentLocation].refine)
		// console.log('newItem.CardSlots')
		// console.log(newItem.CardSlots)
		// newItem.CardSlots.map((cardSlot, index) =>
		// 	newItem.Slots > index
		// 		? cardSlot.changeSlot(
		// 				inventory[currentLocation].CardSlots[
		// 					index
		// 				],
		// 			)
		// 		: null,
		// )
		// props.SetFunction(newItem)

		replaceItemInInventory(newItem)
		props.closeModal()
	}
	return (
		<div>
			<ReactModal
				isOpen={props.modalIsOpen}
				onAfterOpen={afterOpenModal}
				onRequestClose={props.closeModal}
				style={customStyles}
				contentLabel='Example Modal'
			>
				<div
					className='modalHeader'
					style={{
						position: 'sticky',
						top: 0,
						backgroundColor: '#FFFFFF',
					}}
				>
					<h2 ref={(_subtitle) => (subtitle = _subtitle)}>
						{currentLocation}
					</h2>
					<input
						type='text'
						placeholder='Search..'
						onChange={handleTextType}
					/>
					<button onClick={handleClick}>Add</button>
				</div>
				<div className='modalBody'>
					<div className='selectList'>
						{itemList.map((itm) =>
							itm.Name.toUpperCase().includes(
								seachText.toUpperCase(),
							) ? (
								<div
									key={itm.Id}
									className='itemList'
									onClick={
										(e) => props.setLastSelectedItem(itm.Id)
										// 	itm.Id
										// 		? props.setLastSelectedItem(itm.Id)
										// : null
										// (e) => console.log(itm.Id)
									}
								>
									<img
										src={
											'https://images.roprime-simulator.com/item/' +
											//Some items are in idnum2itemresnametable.txt but not all of them
											//if not in idnum2itemresnametable.txt, check iteminfo.lua
											(idnum2itemresnametable[itm.Id] !==
											undefined
												? idnum2itemresnametable[
														itm.Id
													].toLowerCase()
												: '0') +
											'.bmp'
										}
										alt=''
									/>
									{itm.Slots
										? itm.Name + '[' + itm.Slots + ']'
										: itm.Name}
								</div>
							) : null,
						)}
					</div>
					{/* <div className='itemDescModale'> */}
					<ItemDescription
						lastSelectedItem={props.lastSelectedItem}
					/>
					{/* </div> */}
				</div>
			</ReactModal>
		</div>
	)
}

export default EquipmentModal
